import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import Meeting from "../../model2/meeting/meeting"
import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types"

// const debug = "MeetingsResourcesCollection"
const debug = false

export default class MeetingsResourcesCollection extends ResourcesCollectionProto {

    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, Meeting, options)
    }

    processUpdate(update:UpdateAction):boolean {
        debug && console.log(debug, "processUpdate()", update)

        // New
        if (update.updateType === UpdateType.MEETING_NEW) {

            const meeting : Meeting = new Meeting(update.payload)
            this.add(meeting)

            return true // collection changed
        }

        // Change/Delete
        const meeting: Meeting | undefined = this.get(update.payload.id)

        // not found ? -> no update
        if (!meeting) {
            return false
        }

        if (update.updateType === UpdateType.MEETING_DELTA) {
            return meeting.applyDelta(update.payload)
        }

        if (update.updateType === UpdateType.MEETING_DELETE) {
            this.remove(update.payload.id)
            return true // deleted = changed
        }

        // should never get heres
        return false // not changed
    }


}